import React from 'react';
import { Message } from 'rsuite';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, keys } from 'lodash/fp';
import { ColumnSettingsType } from '../../../interfaces/guest';

const ErrorHeading = styled.div`
  font-size: 16px;
  margin-bottom: 5px;
`;

const FieldLabel = styled.span`
  width: 190px;
  text-align: right;
  font-size: 12px;
  font-weight: bold;
  margin-right: 10px;
  margin-bottom: 3px;
  display: inline-block;
`;

const composeFormErrors = (formError, fieldSettings) =>
  keys(formError).map(field => (
    <div key={field}>
      <FieldLabel>{get(`${field}.label`, fieldSettings)} : </FieldLabel>
      {get(field, formError)}
    </div>
  ));

const FormErrorMessageList = ({ formError, fieldSettings }) => (
  <Message
    showIcon
    type="error"
    title={<ErrorHeading>Please correct form error: </ErrorHeading>}
    description={composeFormErrors(formError, fieldSettings)}
    style={{ marginBottom: 20 }}
  />
);

FormErrorMessageList.propTypes = {
  formError: PropTypes.shape({}).isRequired,
  fieldSettings: PropTypes.objectOf(ColumnSettingsType).isRequired
};

export default FormErrorMessageList;
